module.exports = __webpack_public_path__ + "img/11.12fdbae2.svg";